module.exports = __webpack_public_path__ + "static/media/212.4dd4262a.png";